import {inject, Injectable} from '@angular/core';
import {LocalStorageService} from '@services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  private tokenName = "token";
  private refreshTokenName = "refresh_token";
  private local_storage_service = inject(LocalStorageService);

  constructor() { }

  async setTokenStorage(token: string): Promise<void> {
    await this.local_storage_service.setItem(this.tokenName, token);
  }

  setRefreshTokenStorage(refresh_token: string): void {
    this.local_storage_service.setItem(this.refreshTokenName, refresh_token);
  }

  async getTokenStorage(): Promise<string | null>{
    return await this.local_storage_service.getItem(this.tokenName);
  }

  async getRefreshTokenStorage() : Promise<string | null>{
    return await this.local_storage_service.getItem(this.tokenName);
  }

  removeTokenStorage(): void {
    this.local_storage_service.removeItem(this.tokenName);
  }

  removeRefreshTokenStorage(): void {
    this.local_storage_service.removeItem(this.refreshTokenName);
  }

  removeAllTokensStorage(): void {
    this.local_storage_service.removeItem(this.tokenName);
    this.local_storage_service.removeItem(this.refreshTokenName);
  }
}

